// ─────────────────────────────────────────────────────────────────────────────

// NOTE: iOS only
export const useInitializeLiveActivities = () => {};
